const FONT_STYLESHEET_ID = 'chat-widget-font-figtree';

// Injects the Figtree webfont into the host page's <head> once. The widget
// renders inside a Shadow DOM (style-scoped via StyleSheetManager), but
// @font-face registrations made anywhere in the document are available to
// shadow trees, so a single top-level <link> covers every widget instance.
export const loadFont = () => {
  if (document.getElementById(FONT_STYLESHEET_ID)) return;

  const preconnectGoogleapis = document.createElement('link');
  preconnectGoogleapis.rel = 'preconnect';
  preconnectGoogleapis.href = 'https://fonts.googleapis.com';

  const preconnectGstatic = document.createElement('link');
  preconnectGstatic.rel = 'preconnect';
  preconnectGstatic.href = 'https://fonts.gstatic.com';
  preconnectGstatic.crossOrigin = 'anonymous';

  const stylesheet = document.createElement('link');
  stylesheet.id = FONT_STYLESHEET_ID;
  stylesheet.rel = 'stylesheet';
  stylesheet.href = 'https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600;700;800&display=swap';

  document.head.append(preconnectGoogleapis, preconnectGstatic, stylesheet);
};
